import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function useDocumentDirection() {
  const { language } = useLanguage();

  useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);
}
